import angular from 'angular';
import components from './components';

export default angular.module('tabContent.scenes.components', [components])
  .name;
